module.exports = __webpack_public_path__ + "img/04.b6a0910a.png";